<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-course-statistics`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M40 4c1.105 0 2 .814 2 1.818V24h-4V8h-4v11a1 1 0 01-1 1h-2a1 1 0 01-1-1V8H10v32h10v4H8c-1.105 0-2-.814-2-1.818V5.818C6 4.814 6.895 4 8 4h32zm-5 24a1 1 0 011 1v14a1 1 0 01-1 1h-2a1 1 0 01-1-1V29a1 1 0 011-1h2zm-8 6a1 1 0 011 1v8a1 1 0 01-1 1h-2a1 1 0 01-1-1v-8a1 1 0 011-1h2zm16 2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6a1 1 0 011-1h2z"/></svg>
</template>
<script>

export default {
  name: 'IconCourseStatistics',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
